import { render, staticRenderFns } from "./specialSub.vue?vue&type=template&id=13b19d64&scoped=true&"
import script from "./specialSub.vue?vue&type=script&lang=js&"
export * from "./specialSub.vue?vue&type=script&lang=js&"
import style0 from "./specialSub.vue?vue&type=style&index=0&id=13b19d64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!///node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b19d64",
  null
  
)

export default component.exports